<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">お知らせ管理</li>
            </ol>
        </nav>
        <div class="container">
            <div class="forms">
                <div class="form-group">
                    <label>
                        タイトル
                        <span class="small">
                            ( {{notice.subject.length}} / 30文字 )
                        </span>
                    </label>
                    <input type="text" class="form-control bg-white" v-model="notice.subject" />
                    <div class="text-muted small">
                        タイトルは通知に表示されません。
                    </div>
                    <label>内容</label>
                    <editor ref="editor"
                        class="b-light"
                        :minHeight="50"
                        @saved="saved"
                        :content="$filters.jsonParse(notice.topic)"></editor>
                    <editor-storage
                        :content="notice.topic"
                        :max="2097152"></editor-storage>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <button type="button" class="btn btn-outline-secondary" @click="cancel()" v-if="notice.id">
                            <i class="fas fa-backspace"></i>
                            キャンセル
                        </button>
                    </div>
                    <div class="col-md-6 text-right">
                        <button type="button" class="btn btn-outline-primary" @click="save()">
                            <i class="fas fa-plus"></i>
                            告知を投稿
                        </button>
                    </div>
                </div>
            </div>
            <div class="sticky">
                <page :last_page="notices.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div class="card my-4" v-for="n in notices.data" :key="n.id">
                <div class="card-header">
                    <button type="button" @click="edit(n)" class="btn btn-link btn-sm">
                        <i class="fas fa-edit"></i>
                    </button>
                    <h5 class="inline">
                    {{n.subject}}
                    </h5>
                    <button type="button" @click="removeNotice(n)" class="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="card-body">
                    <editor
                        :id="'notice-' + n.id"
                        :ref="'notice_' + n.id"
                        :readOnly="true"
                        :minHeight="0"
                        :content="$filters.jsonParse(n.topic)"></editor>
                </div>
                <div class="card-footer text-right small">
                    {{$filters.dateFormat(n.created_at)}}
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.forms {
    margin: 1rem auto 3rem;
}
.inline {
    display: inline;
}
#block-editor {
    border-radius: .7rem;
    padding-top: 2rem;
}
</style>

<script>
import page from "components/Page";
export default {
    components: {
        page
    },
    data() {
        return {
            notices: {},
            page: 1,
            notice: {
                subject: "",
                topic: "",
            },
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        load() {
            axios.get("/admin/notices/get", {params: {page: this.page}}).then(res => {
                this.notices = res.data;
            }).catch(err => { alert.err(err.response); });
        },
        edit(n) {
            axios.get("/admin/notice/get", {params: {id: n.id}}).then(res => {
                this.notice = res.data;
                this.$refs.editor.refresh();
            }).catch(err => { alert.err(err.response); });
        },
        cancel() {
            this.notice = {
                subject: "",
                topic: "",
            };
        },
        removeNotice(n) {
            Swal.fire({
                title: "お知らせ削除",
                text: "指定のお知らせを削除します。よろしいですか？",
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/admin/notice/remove", {'id': n.id}).then(res => {
                        alert.msg(res.data);
                        this.goto(1);
                    }).catch(err => { alert.err(err.response); });
                }
            });
        },
        saved(ev) {
            this.notice.topic = JSON.stringify(ev);
        },
        async save() {
            const save_data = await this.$refs.editor.save();
            this.notice.topic = JSON.stringify(save_data);
            axios.post("/admin/notice/save", this.notice).then(res => {
                alert.msg(res.data);
                this.notice = {
                    subject: "",
                    topic: "",
                };
                this.$refs.editor.refresh();
                this.goto(1);
            }).catch(err => { alert.err(err); });
        }
    },
    mounted() {
        this.load();
    }
}
</script>